var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "46px",
    viewBox: "0 0 70 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Option-1",
    transform: "translate(-471.000000, -393.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(472.000000, 394.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68,41.6365092 C68,42.942087 66.9326582,44 65.6167722,44 L2.38322785,44 C1.06626582,44 0,42.942087 0,41.6365092 L0,2.36455831 C0,1.05898052 1.06626582,0 2.38322785,0 L65.6167722,0 C66.9326582,0 68,1.05898052 68,2.36455831 L68,41.6365092 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    points: "67 3 34 25 1 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 39,
    x2: 21,
    y2: 26,
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67,
    y1: 39,
    x2: 47,
    y2: 27,
    id: "Stroke-7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.bc6a4208e5582c6aef4da604f3dca4ad.svg";
export { ForwardRef as ReactComponent };